import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-search-with-filter',
  templateUrl: './search-with-filter.component.html',
  styleUrls: ['./search-with-filter.component.scss'],
  standalone: false
})
export class SearchWithFilterComponent implements AfterViewInit {
  @Input() externalClearSearch?: () => void;
  @Input() useExternalClearSearch: boolean = false;

  @Input() placeholder: string = '';
  @Input() search: string = '';
  @Output() searchChange = new EventEmitter<string>();

  @Input() hasActiveFilters = false;
  @Input() showFilter: boolean = true;
  @Output() filterClicked = new EventEmitter<void>();

  @ViewChild('searchBarInline') inputRef!: ElementRef<HTMLInputElement>;
  private shouldFocus = false;

  ngAfterViewInit(): void {
    if (this.shouldFocus) {
      this.focusInput();
    }
  }

  public focusInput() {
    this.shouldFocus = true;
    setTimeout(() => {
      this.inputRef?.nativeElement?.focus();
    }, 0);
  }

  onFilterClick() {
    this.filterClicked.emit();
  }

  clearSearch() {
    if (this.useExternalClearSearch && this.externalClearSearch) {
      this.externalClearSearch();
    } else {
      this.search = '';
      this.searchChange.emit('');
    }
  }
}
